import { tmrDialogController } from 'tmr/controllers/dialog/dialog'
import templateUrl from './sessionMovementTransferToZoneDialog.html'
import './sessionMovementTransferToZoneDialog.scss'

/**
 * Configures dialog Items by Upc (preset `tmrSessionMovementTransferToZone`).
 *
 * @type {ngConfig}
 */
function tmrSessionMovementTransferToZoneDialogConfig($mdDialogProvider) {
  'ngInject'
  $mdDialogProvider.addPreset('tmrSessionMovementTransferToZone', {
    options: /*@ngInject*/ () => ({
      templateUrl,
      clickOutsideToClose: false,
      fullscreen: true,
      controller: 'tmrSessionMovementTransferToZoneDialogController',
      controllerAs: '$ctrl',
      bindToController: true,
      locals: {
        session: null,
      },
    }),
  })
}

export { tmrSessionMovementTransferToZoneDialogConfig as config }

/**
 * Controller of Dialog {@link tmrSessionMovementTransferToZoneDialogConfig tmrSessionMovementTransferToZone}.
 *
 * @type {ngController}
 */
export class tmrSessionMovementTransferToZoneDialogController extends tmrDialogController {
  constructor(
    $mdDialog,
    $transitions,
    Session,
    SessionMovement,
    SessionItem,
    TmrToast
  ) {
    'ngInject'
    super($mdDialog, $transitions)
    Object.assign(this, { Session, SessionMovement, SessionItem, TmrToast })
  }

  $onInit() {
    super.$onInit()
    this.querySessionMovements()
    this.sessionItems = []
    this.deleteClicked = false
  }

  // abort phase to phase process
  onClickAbort() {
    this.$mdDialog.hide()
  }

  // SessionMovements methods
  getSessionMovements(value) {
    if (!value) {
      this.sessionMovementsFiltered = this.sessionMovements
      this.deleteClicked = false
    } else {
      const valueLower = value.toLowerCase()
      this.sessionMovementsFiltered = this.sessionMovements.filter(
        sessionMovement => {
          const description = sessionMovement.description
            ? sessionMovement.description.toLowerCase()
            : ''
          const code = sessionMovement.code
            ? sessionMovement.code.toLowerCase()
            : ''
          return description.includes(valueLower) || code.includes(valueLower)
        }
      )
    }
  }

  querySessionMovements() {
    this.SessionMovement.query({ 'session.id': this.session.id }).$promise.then(
      sessionMovements => {
        this.sessionMovements = sessionMovements
        this.sessionMovementsFiltered = sessionMovements
        this.sessionMovementText = ''
        this.sessionMovement = null
        this.sessionItems = []
        this.groupedSessionItems = {}
      }
    )
  }

  getSessionItems() {
    this.groupedSessionItems = {}
    this.sessionItems = []
    if (!this.sessionMovement) return
    this.SessionItem.query({
      'sessionMovement.id': this.sessionMovement.id,
    }).$promise.then(sessionItems => {
      this.sessionItems = sessionItems
      sessionItems.forEach(element => {
        if (this.groupedSessionItems[element.upc]) {
          this.groupedSessionItems[element.upc].quantity++
        } else {
          this.groupedSessionItems[element.upc] = {}
          this.groupedSessionItems[element.upc].upc = element.upc
          this.groupedSessionItems[element.upc].quantity = 1
          this.groupedSessionItems[element.upc].description =
            element.product.description
        }
      })
    })
  }

  deleteSessionMovement() {
    this.sessionMovement.$delete().then(() => {
      this.TmrToast.success(
        'OPERATIONS.SESSIONTRANSFERTOZONE.SESSIONMOVEMENTDELETE',
        'messageformat'
      ),
        this.querySessionMovements()
      this.deleteClickedChange()
    })
  }

  deleteClickedChange() {
    this.deleteClicked = !this.deleteClicked
  }
}
